import { MapfreModalComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, Output, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent],
  selector: 'app-upload-type-modal',
  templateUrl: './upload-type-modal.component.html',
  styleUrls: ['./upload-type-modal.component.scss']
})
export class UploadTypeModalComponent implements OnInit {

  @ViewChild(MapfreModalComponent) modalComponent!: MapfreModalComponent;
  @Input() actionType: string;
  @Input() policy: string;
  @Input() onModalLoad: boolean;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  uploadTypeModalOptions: ModalOptions;
  hideModal: boolean;
  imgPath: string;
  isAcmic:boolean

  constructor(
    private router: Router,
    private acmicService: AcmicService
  ) {
    this.hideModal = false;
    this.isAcmic=acmicService.isACMIC();
    this.actionType = this.isAcmic?'upload-type-btn add-doc-upload-btn':'upload-type-btn upload-type-btn-ma';
   }

  openUploadDocPage() {
    this.router.navigate(['/billing', 'upload-files'], 
    { state: { policyData: this.policy }});
  }
  openClaimUploadDocPage() {
    this.router.navigate(['/claims']);
  }
  setModalOptions() {
    this.uploadTypeModalOptions = new ModalOptions({
      additionalClasses: 'modal-medium modal-center-on-page modal-dialog upload-document-modal' ,
      additionalButtonClasses: this.actionType,
      animatePosition: 'bottom',
      buttonCopy: 'Upload documents',
      modalId: 'uploadTypeModal',
      typeOfModal: 'default',
      modalName: 'upload_Type_Modal',
      onLoad: this.onModalLoad ? true : false,
    });
  }
  hideModalAction(): void {
    this.hideModal = !this.hideModal;
  }

  openModal(): void {
    this.modalComponent.showModal();
  }

  hideOnClick(event): void {
    void event;
    this.closeModal.emit(true);
  }

  ngOnInit(): void {
    this.setModalOptions();
    this.imgPath = this.acmicService.isACMIC() ?
     'assets/img/images/icon-simple-arrow-right-blue.svg' :
    'assets/img/images/icon-simple-arrow-right-red.svg';
  }

}
